import { Component } from '@angular/core';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './not-allowed.component.html',
  styleUrl: './not-allowed.component.scss'
})
export class NotAllowedComponent {

}
